import React from "react";
import styles from "./BuiltForRealWorldUse.module.css";
import img1 from "../../../Images/chatbot_img1.png";
import img2 from "../../../Images/chatbot_img2.png";
import img3 from "../../../Images/chatbot_img3.png";
import img4 from "../../../Images/chatbot_img4.png";


const features = [
    {
        title: "Voice AI Agents",
        desc: "Run conversational agents with speech so natural customers assume they're human.",
        points: [
            "Human-like, interruption-aware speech",
            "Emotionally adaptive responses",
            "Real-time, low-latency streaming",
        ],
        result: "Higher trust. Longer conversations. Fewer handoffs.",
        image: img1,
    },
    {
        title: "IVR Systems",
        desc: "Replace rigid, robotic IVRs with dynamic voice experiences people don't hang up on.",
        points: [
            "AI-generated prompts in real time",
            "Multi-language and accent support",
            "Consistent brand voice across flows",
        ],
        result: "Better caller experience. Lower drop-offs. Faster resolution.",
        image: img2,
        reverse: true,
    },
    {
        title: "Outbound Campaigns",
        desc: "Scale high-volume voice outreach without sounding scripted or cold.",
        points: [
            "Millions of calls per day, reliably",
            "Personalized, context-aware messaging",
            "Emotional tone matched in real time",
        ],
        result: "Higher engagement without burning brand trust.",
        image: img3,
    },
    {
        title: "Content & Accessibility",
        desc: "Produce high-quality audio without studio costs or production delays.",
        points: [
            "Studio-grade voiceovers",
            "Multiple voices and styles",
            "Ideal for video, e-learning, audiobooks",
        ],
        result: "Faster content cycles at a fraction of the cost.",
        image: img4,
        reverse: true,
    },
];

export default function BuiltForRealWorldUse() {
    return (
        <section className={styles.wrapper}>
            <h2 className={styles.heading}>Built for Real-World Use</h2>
            <p className={styles.subheading}>
                From live voice agents to large-scale content production.
            </p>

            <div className={styles.list}>
                {features.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.card} ${item.reverse ? styles.reverse : ""}`}
                    >
                        <div className={styles.textBlock}>
                            <div className={styles.titleRow}>
                                <span className={styles.icon} />
                                <h3>{item.title}</h3>
                            </div>
                            <p className={styles.desc}>{item.desc}</p>
                            <ul>
                                {item.points.map((p, i) => (
                                    <li key={i}>{p}</li>
                                ))}
                            </ul>
                            <div className={styles.result}>Result: {item.result}</div>
                        </div>

                        <div className={styles.imageWrap}>
                            <img src={item.image} alt={item.title} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
